var _desc;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCadence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51.02mm",
    height: "9.642mm",
    viewBox: "0 0 51.02 9.642",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cadence Design Systems logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A software company based in San Jose, California, United States that specialised in EDA")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.07 40.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.081-39.63h3.903v-1.074h-3.903z",
    style: {
      fill: "#d21c2e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5857 0 0 -.5857 -6.335 -31.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.355-0.189-0.99-0.379-1.841-0.379-2.729 0-4.543 2.021-4.543 5.801 0 3.443 1.905 6.028 4.951 6.028 0.679 0 1.12-0.165 1.433-0.334v-2c-0.249 0.102-0.829 0.257-1.383 0.257-1.641 0-2.487-1.786-2.487-3.901 0-2.351 0.95-3.783 2.489-3.783 0.464 0 1.014 0.091 1.381 0.273v-1.962",
    style: {
      fill: "#231f20"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5857 0 0 -.5857 -.6332 -32.24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 1e-3 4.054c-0.98-0.013-2.759-0.284-2.759-2.285 0-1.299 0.692-1.768 1.246-1.768zm2.482 0.916c0-0.892 0.055-2.029 0.177-2.791h-4.931c-1.648 0-2.892 1.368-2.892 3.384 0 2.955 2.497 4.202 5.098 4.226v0.203c0 1.198-0.469 2.04-1.718 2.04-0.822 0-1.762-0.24-2.384-0.638v1.72c0.565 0.359 1.531 0.822 2.932 0.822 2.96 0 3.718-1.924 3.718-4.371v-4.595",
    style: {
      fill: "#231f20"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5857 0 0 -.5857 7.314 -32.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-1.468c-1.057 0-1.669 1.595-1.669 3.891 0 2.056 0.456 3.87 1.731 3.87 0.744 0 1.261-0.818 1.369-1.742 0.037-0.233 0.037-0.489 0.037-0.708zm2.511 0.901-5e-3 12.36h-2.506v-4.614h-0.048c-0.368 0.794-1.064 1.249-2.012 1.249-1.857 0-3.59-1.936-3.59-5.971 0-3.464 1.248-5.809 3.472-5.809l4.866-4e-3c-0.121 0.763-0.177 1.898-0.177 2.79",
    style: {
      fill: "#231f20"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5857 0 0 -.5857 15.23 -35.17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.019 1.845-0.586 2.941-1.48 2.941-1.095 0-1.588-1.593-1.638-2.941zm-3.129-1.794c0.027-2.57 1.22-3.268 2.562-3.268 0.84 0 1.73 0.189 2.241 0.408v-1.813c-0.717-0.338-1.647-0.541-2.698-0.541-2.964 0-4.555 2.15-4.555 5.709 0 3.803 1.823 6.118 4.278 6.118 2.418 0 3.636-2.185 3.636-5.267 0-0.656-0.026-1.026-0.066-1.341l-5.398-5e-3",
    style: {
      fill: "#231f20"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5857 0 0 -.5857 21.26 -36.74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-9.564h-2.52v8.257c0 1.299-0.065 2.316-0.103 3.334h4.968c1.915 0 3.056-1.394 3.056-4.06v-7.531h-2.52v7.291c0 1.149-0.244 2.271-1.341 2.271l-1.54 2e-3",
    style: {
      fill: "#231f20"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5857 0 0 -.5857 31.3 -31.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.355-0.189-0.991-0.379-1.841-0.379-2.729 0-4.545 2.021-4.545 5.801 0 3.443 1.906 6.028 4.952 6.028 0.68 0 1.12-0.165 1.434-0.334v-2c-0.25 0.102-0.83 0.257-1.384 0.257-1.641 0-2.487-1.786-2.487-3.901 0-2.351 0.949-3.783 2.49-3.783 0.465 0 1.013 0.091 1.381 0.273v-1.962",
    style: {
      fill: "#231f20"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5857 0 0 -.5857 35.36 -35.17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.051 1.348 0.544 2.941 1.637 2.941 0.896 0 1.501-1.096 1.481-2.941zm5.452-0.448c0 3.083-1.217 5.267-3.635 5.267-2.454 0-4.279-2.315-4.279-6.118 0-3.559 1.591-5.709 4.555-5.709 1.053 0 1.983 0.203 2.699 0.541v1.813c-0.513-0.219-1.401-0.408-2.241-0.408-1.343 0-2.534 0.698-2.561 3.268l5.397 5e-3c0.04 0.315 0.065 0.685 0.065 1.341",
    style: {
      fill: "#231f20"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5857 0 0 -.5857 40.06 -40.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.834 0 1.513-0.775 1.513-1.728 0-0.951-0.679-1.726-1.513-1.726-0.836 0-1.512 0.775-1.512 1.726 0 0.953 0.676 1.728 1.512 1.728zm5e-3 -3.196c0.696 0 1.219 0.641 1.219 1.468 0 0.829-0.523 1.469-1.219 1.469-0.704 0-1.228-0.64-1.228-1.469 0-0.827 0.524-1.468 1.228-1.468zm-0.584 2.483h0.68c0.406 0 0.608-0.186 0.608-0.569 0-0.326-0.181-0.559-0.459-0.559l0.504-0.895h-0.305l-0.496 0.895h-0.243v-0.895h-0.289zm0.289-0.87h0.343c0.224 0 0.366 0.052 0.366 0.315 0 0.23-0.18 0.297-0.366 0.297h-0.343v-0.612",
    style: {
      fill: "#231f20"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadence);
export default __webpack_public_path__ + "static/media/cadence.9e009e5a756ef5dadaffb6b832db442d.svg";
export { ForwardRef as ReactComponent };